// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"15f78ba9","2071":"0a375583","3479":"15f78ba9","8777":"fe58350d"}[chunkId] + ".chunk.css";
};